// const atencionLaboratoriosLS = localStorage.getItem('atencionLaboratorios')
//   ? JSON.parse(localStorage.getItem('atencionLaboratorios'))
//   : [];


export default {
  state:{
    laboratoriosAs400 : {
      estudioLab: null,
      inicial: [],
      final  : [],
    },

    laboratoriosAux   : [],
  },

  
  mutations: {
    setLaboratorioList( state, data) {
      state.laboratorioList = data
    },


    setLaboratoriosAs400EstudioLab( state, newData) {
      state.laboratoriosAs400.estudioLab =  newData
    },

    setLaboratoriosAs400Inicial( state, newData) {
      state.laboratoriosAs400.inicial =  newData
    },

    setLaboratoriosAs400Final(state, newData){
      state.laboratoriosAs400.final = newData
    },


    resetLabAs400( state ) {
      state.laboratoriosAs400 = {
        estudioLab: null,
        inicial: [],
        final  : [],
      }
    },

    setLaboratoriosAux(state, data){
      state.laboratoriosAux = data
    },

    resetLaboratoriosAux( state ) {
      state.laboratoriosAux = []
    },
  }
}
  